<template>
    <div class="simple-card" @click="click">
        <slot name="top">
            <div class="title">
                <div class="text">{{title}}</div>
                <div class="is_new" v-if="isNew">
                    <div class='is_new_item'></div>
                </div>
            </div>
        </slot>
        <div class="content"><slot></slot></div>
        <slot name="footer"></slot>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        isNew:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        click(){
            this.$emit('click')
        }
    }
}
</script>
<style lang="less" scoped>
.simple-card{
    padding:0.2rem 0.16rem;
    background:#ffffff;
    .title{
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        display: flex;
        .text{
            flex: 1;
        }
        .is_new{
            margin-left: 0.05rem;
            .is_new_item{
                width: 26px;
                height: 12px;
                margin-top: 3px;
                background:url(../assets/images/is_new.png) no-repeat;
                background-size: cover;
            }
        }
    }
    .content{
        margin:0.12rem 0 0.08rem 0 ;
    }
}
</style>